import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Grid,
} from "@mui/material";
import { useServiceInscripcionCursos } from "hooks/inscripcionCursos/useInscripcionCursos";
import { useEffect } from "react";
import { CardsCursos } from "./cardCursos";
import { ModalDatosInscripcion } from "./modalDatosInscripcion";
import { CardCursoVigente } from "./cardCursoVigente";
import { useAuthStore } from "hooks/useAuthStore";
import { Link } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";

interface CursoProps {
  origen?: string;
}

export const InscripcionCursosForm = ({ origen }: CursoProps) => {
  const { user } = useAuthStore();
  const {
    cursoSelecccionado,
    mostrarLstCursos,
    startGetCursos,
    startGetCursoVigente,
    setOpenModalInscripcion,
    setEnviado,
  } = useServiceInscripcionCursos();

  useEffect(() => {
    startGetCursos(
      user?.session?.cveUsuario ? user?.session?.cveUsuario : null
    );
    startGetCursoVigente(
      user?.session?.cveUsuario ? user?.session?.cveUsuario : null
    );
  }, []);

  useEffect(() => {
    setEnviado(false);
  }, [user?.session?.cveUsuario]);

  useEffect(() => {
    if (cursoSelecccionado !== null) {
      setOpenModalInscripcion(true);
      setEnviado(false);
    }
  }, [cursoSelecccionado]);

  return (
    <>
      <Grid container spacing={2}>
        <Card
          className={
            origen === "login"
              ? "w-full"
              : "w-full md:w-full lg:w-5/6 xl:w-5/6 mx-auto my-6"
          }
        >
          <CardHeader
            title="Inscripción a Cursos"
            style={{ backgroundColor: "#7c1f0d", color: "#fff" }}
          />
          <Divider />
          <CardContent className="overflow-y-auto mx-auto">
            <div className="mx-auto">
              <Grid item xs={12}>
                {mostrarLstCursos ? (
                  <CardsCursos />
                ) : (
                  <CardCursoVigente origen={origen} />
                )}
              </Grid>
            </div>
          </CardContent>
        </Card>
        {origen === "login" ? (
          <CardActions>
            <>
              <div className="my-5 mx-auto">
                {" "}
                <Link to="/login">
                  <Button
                    startIcon={<FiArrowLeft />}
                    type="button"
                    variant="contained"
                    color="error"
                  >
                    REGRESAR
                  </Button>
                </Link>
              </div>
            </>
          </CardActions>
        ) : null}
      </Grid>
      <ModalDatosInscripcion origen={origen} />
    </>
  );
};
